import React from "react";
import { setdata } from "../../../../../../../helpers/helpers";
import ProductGridView from "./ProductGridView";
import ProductListView from "./ProductListView";
import { showSnackBar } from "../../../../../../../store/common/snackBarSlice";
import { useDispatch, useSelector } from "react-redux";

import { nextLinkKey } from "../LinkColor/linkColors";
import { showFulfilmentLocation } from "../FulfilmentLocation/showFulfilmentLocation";
import ProductsLocationLine from "./ProductsLocationLine";
import { LibraryFrame, useLibraryView } from "./LibraryFrame";

export default function ProductScroller(props) {
  const {
    Plist,
    SetPlist,
    StepCheck,
    SetStepCheck,
    SelectedProducts,
    setSelectedProducts,
    view,
    setView,
  } = props;
  const dispatch = useDispatch();
  const handleStepper = () => {
    SetStepCheck((prevStepCheck) => ({
      ...prevStepCheck,
      Packages_bit: 0,
      QuoteCheck: false,
    }));
  };

  const user = useSelector((state) => state.user);
  const hasLocations =
    Array.isArray(user?.user_approved_warehouses) &&
    user.user_approved_warehouses.length > 0;

  const handlescrollpackage = (data) => {
    // No location yet: say so and take the user to the Fulfilment
    // Location card, the only place to choose one. An account with no
    // approved warehouse has no card, so it is only told why.
    if (!StepCheck["Warehouses"]) {
      dispatch(
        showSnackBar({
          text: hasLocations
            ? "Select a location first"
            : "No fulfilment location is set up for this account yet",
          severity: "info",
        })
      );
      if (hasLocations) showFulfilmentLocation();
      return;
    }
    dispatch(
      showSnackBar({
        text: `${data?.name ?? "Product"} Added Successfully`,
        severity: "success",
      })
    );
    const productId = data.id;

    const existingProductIndex = SelectedProducts.findIndex(
      (product) => product.id === productId
    );

    // One colour per product, reused on every later add, so bumping the
    // quantity never re-colours a product that is already linked. Every
    // package cut from it below inherits this key.
    const linkKey =
      SelectedProducts[existingProductIndex]?.link_key ||
      nextLinkKey(SelectedProducts.map((product) => product?.link_key));

    if (existingProductIndex !== -1) {
      const updatedProducts = [...SelectedProducts];
      updatedProducts[existingProductIndex].quantity += 1;
      updatedProducts[existingProductIndex].link_key = linkKey;
      setSelectedProducts(updatedProducts);
    } else {
      const newData = { ...data, quantity: 1, link_key: linkKey };
      setSelectedProducts([...SelectedProducts, newData]);
    }

    if (data?.package_details?.length > 0) {
      const x = Plist.length - 1;
      if (
        Plist[x]["name"] === "" &&
        Plist[x]["length"] === "" &&
        Plist[x]["width"] === "" &&
        Plist[x]["height"] === "" &&
        Plist[x]["weight"] === "" &&
        Plist[x]["description"] === "" &&
        Plist[x]["insurance"] === ""
      ) {
        SetPlist((prevPlist) => {
          const newPackages = Object.entries(data.package_details).map(
            ([packageId, packageItem]) => ({
              name: data.name,
              length: setdata(() => packageItem.length, false, ""),
              width: setdata(() => packageItem.width, false, ""),
              height: setdata(() => packageItem.height, false, ""),
              weight: setdata(() => packageItem.weight, false, ""),
              description: packageItem.description,
              insurance: "",
              volume: (
                (setdata(() => packageItem.length, false, 0) *
                  setdata(() => packageItem.width, false, 0) *
                  setdata(() => packageItem.height, false, 0)) /
                1000000
              ).toFixed(2),
              warehouse_id: StepCheck["Warehouses"],
              product_id: data.id,
              link_key: linkKey,
            })
          );
          return [...newPackages];
        });
      } else {
        SetPlist((prevPlist) => [
          ...prevPlist,
          ...Object.entries(data.package_details).map(
            ([packageId, packageItem]) => ({
              name: data.name,
              length: setdata(() => packageItem.length, false, ""),
              width: setdata(() => packageItem.width, false, ""),
              height: setdata(() => packageItem.height, false, ""),
              weight: setdata(() => packageItem.weight, false, ""),
              description: packageItem.description,
              insurance: "",
              volume: (
                (setdata(() => packageItem.length, false, 0) *
                  setdata(() => packageItem.width, false, 0) *
                  setdata(() => packageItem.height, false, 0)) /
                1000000
              ).toFixed(2),
              warehouse_id: StepCheck["Warehouses"],
              product_id: data.id,
              link_key: linkKey,
            })
          ),
        ]);
      }
    } else {
      const x = Plist.length - 1;
      if (
        Plist[x]["name"] === "" &&
        Plist[x]["length"] === "" &&
        Plist[x]["width"] === "" &&
        Plist[x]["height"] === "" &&
        Plist[x]["weight"] === "" &&
        Plist[x]["description"] === "" &&
        Plist[x]["insurance"] === ""
      ) {
        // A new row object with the same keys in the same order (the request
        // bodies are byte-identical). Writing into the empty row itself
        // changed the shared row it can be (PackageList's initialPackageRow
        // after the single-row trash, or Ship.jsx's first row), so the
        // product came back in Add new row and later visits (KNOWN_ISSUES
        // SP-029, fixed 2026-10-20).
        const plist = [...Plist];
        plist[x] = {
          ...plist[x],
          name: data.name,
          length: setdata(() => data.length, false, ""),
          width: setdata(() => data.width, false, ""),
          height: setdata(() => data.height, false, ""),
          weight: setdata(() => data.weight, false, ""),
          volume: (
            (setdata(() => data.length, false, 0) *
              setdata(() => data.width, false, 0) *
              setdata(() => data.height, false, 0)) /
            1000000
          ).toFixed(2),
          description: data.full_name,
          insurance: "",
          warehouse_id: StepCheck["Warehouses"],
          product_id: data.id,
          link_key: linkKey,
        };
        SetPlist(plist);
      } else {
        SetPlist([
          ...Plist,
          {
            name: data.name,
            length: setdata(() => data.length, false, ""),
            width: setdata(() => data.width, false, ""),
            height: setdata(() => data.height, false, ""),
            weight: setdata(() => data.weight, false, ""),
            description: data.full_name,
            insurance: "",
            warehouse_id: StepCheck["Warehouses"],
            product_id: data.id,
            link_key: linkKey,
            volume: (
              (setdata(() => data.length, false, 0) *
                setdata(() => data.width, false, 0) *
                setdata(() => data.height, false, 0)) /
              1000000
            ).toFixed(2),
          },
        ]);
      }
    }
    handleStepper();
    // handleClose();
  };

  const library = useLibraryView(view, setView);

  // The Warehouse dropdown lived in the row above the list; the Fulfilment
  // Location card replaced it (2026-10-17). The location line now comes
  // before the switches.
  return (
    <LibraryFrame
      view={view}
      library={library}
      StepCheck={StepCheck}
      SetStepCheck={SetStepCheck}
      lead={<ProductsLocationLine StepCheck={StepCheck} />}
      barClass="product__scroller_wrap_main_container"
      grid={
        <ProductGridView
          StepCheck={StepCheck}
          handlescrollpackage={handlescrollpackage}
          setFilter={library.setFilter}
        />
      }
      list={(actions) => (
        <ProductListView
          StepCheck={StepCheck}
          handlescrollpackage={handlescrollpackage}
          headerButtons={actions}
        />
      )}
    />
  );
}
